import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgNft = function SvgNft(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 121"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#29233B",
        d: "M54.853 1.535a11.23 11.23 0 0 1 11.225 0l42.24 24.388a11.23 11.23 0 0 1 5.613 9.72V84.42c0 4.01-2.14 7.716-5.613 9.72l-42.24 24.388a11.22 11.22 0 0 1-11.225 0L12.613 94.14A11.23 11.23 0 0 1 7 84.419V35.644c0-4.01 2.14-7.716 5.612-9.721z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M40.03 82.48q.43 0 .866-.12c1.7-.475 2.903-2.28 2.903-4.358V42.168c0-2.473-1.689-4.48-3.77-4.48s-3.77 2.007-3.77 4.48v16.86l-7.936-18.863c-.784-1.859-2.518-2.83-4.24-2.355-1.7.474-2.903 2.28-2.903 4.358v35.834c0 2.472 1.689 4.479 3.77 4.479s3.77-2.007 3.77-4.48v-16.86l7.935 18.862c.652 1.546 1.968 2.477 3.374 2.477M69.964 46.647c2.084 0 3.77-2.007 3.77-4.48 0-2.472-1.686-4.479-3.77-4.479h-15.08c-2.08 0-3.77 2.007-3.77 4.48v35.834c0 2.472 1.69 4.479 3.77 4.479s3.77-2.007 3.77-4.48V64.565h7.54c2.084 0 3.77-2.007 3.77-4.48 0-2.472-1.686-4.479-3.77-4.479h-7.54v-8.958zM96.622 37.582h-15.08c-2.085 0-3.77 2.006-3.77 4.479 0 2.472 1.685 4.479 3.77 4.479h3.77v31.355c0 2.472 1.686 4.479 3.77 4.479s3.77-2.007 3.77-4.48V46.54h3.77c2.085 0 3.77-2.007 3.77-4.48 0-2.472-1.685-4.479-3.77-4.479"
    })));
};

export { SvgNft as ReactComponent };
//# sourceMappingURL=NFT.svg.es.js.map
